module.exports = __webpack_public_path__ + "static/img/zzx.07361e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/zzx.png
// module id = CCVn
// module chunks = 42